import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getSubmissionJSON } from '../submissions/constants/handleSubmission';

const Header = ({ current_user, noRouter }) => {
  const determineIcon = 'internal_link' in current_user ? 'globe' : 'home';
  const [subSearchError, setSubSearchError] = useState('');
  const [subId, setSubId] = useState('');
  const navigate = noRouter ? null : useNavigate();

  const handleSubInputChange = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      goToSub();
    }
  };
  const goToSub = async () => {
    let id = subId;
    if (id) {
      let validInput = /^[1-9][0-9]*$/;
      if (validInput.test(id)) {
        let submission = await getSubmissionJSON(id);
        if (submission.ok) {
          noRouter
            ? (window.location = `/manage/submissions/${id}`)
            : navigate(`/manage/submissions/${id}`);
        } else {
          let subError =
            submission.status === 404
              ? 'Record not found.'
              : submission.status === 401
                ? 'Unauthorized to view this record.  If you think this is a mistake, please contact IT.'
                : 'Unknown error occurred... try again later.';
          setSubSearchError(subError);
        }
      } else {
        setSubSearchError('Invalid Submission ID.');
      }
    }
  };
  // Provide non-Router href links if on externals index page or if rendering errors.html.erb
  const noRouterList = (
    <>
      {current_user.admin ? (
        <>
          <li>
            <a href='/manage'>Containers</a>
          </li>
          <li>
            <a href='/manage/permissions'>Permissions</a>
          </li>
          <li>
            <a href='/manage/queue' target='_blank'>
              Sidekiq Dash
            </a>
          </li>
        </>
      ) : (
        <li>
          <a href='/manage'>Containers</a>
        </li>
      )}
      <li>
        <a href='/manage/global_search'>Search</a>
      </li>
    </>
  );

  return (
    <header className='top-bar manage-header'>
      <nav className='left'>
        <ul>
          {noRouter ? (
            noRouterList
          ) : (
            <>
              <li>
                <Link to='/manage'>Containers</Link>
              </li>
              {current_user.admin && (
                <>
                  <li>
                    <Link to='/manage/permissions'>Permissions</Link>
                  </li>
                  <li>
                    <a href='/manage/queue' target='_blank'>
                      Sidekiq Dash
                    </a>
                  </li>
                </>
              )}
              <li>
                <Link to='/manage/global_search'>Search</Link>
              </li>
            </>
          )}
          <li className='sub-id-search'>
            <input
              type='text'
              placeholder='Submission ID...'
              className={subSearchError ? 'highlight' : ''}
              value={subId}
              onKeyDown={(e) => handleSubInputChange(e)}
              onChange={(e) => {
                if (!e.target.value) setSubSearchError('');
                setSubId(e.target.value);
              }}
            />
            <div
              style={{
                opacity: subId ? '100%' : '0',
                transition: 'opacity 0.5s ease',
                cursor: subId ? 'pointer' : 'default',
              }}
            >
              <i
                className='fa-solid fa-circle-xmark'
                title='Clear'
                onClick={(e) => {
                  setSubSearchError('');
                  setSubId('');
                }}
              />
            </div>
          </li>
          <li
            style={{
              opacity: subId ? '100%' : '0',
              transition: 'opacity 0.5s ease',
            }}
          >
            <a
              onClick={(e) => {
                if (subId) goToSub();
              }}
              title='Go to Submission'
              style={{
                cursor: subId ? 'pointer' : 'default',
              }}
            >
              <i className='fa-solid fa-arrow-right-to-bracket' />
            </a>
          </li>
          <li style={{ border: 'none' }}>
            <div
              className='errors'
              style={{
                padding: '0.6em 0.8em',
              }}
            >
              {subSearchError && <span>{subSearchError}</span>}
            </div>
          </li>
        </ul>
      </nav>

      <nav className='right'>
        <ul>
          <li className='has-dropdown'>
            <a className='userName' href='#'>
              {current_user.name + ' '}
              <i
                className={'fa-solid fa-' + determineIcon}
                aria-hidden='true'
              ></i>
            </a>
            <ul className='dropdown'>
              <li>
                <a href='/sign_out'>
                  Logout{' '}
                  <i
                    className='fa-solid fa-right-from-bracket right'
                    aria-hidden='true'
                  />
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
